import TWEEN from '@tweenjs/tween.js';

export default function fall() {
  var _this = this;
  // this.movePath.shift();
  new TWEEN.Tween(this.ball)
    .to({ y: this.fisrtPinY - this.ballRadius - this.pinRadius }, 200)
    .easing(TWEEN.Easing.Sinusoidal.In)
    .onComplete(function () {
      _this.nextStep();
    })
    .start();
}
